import { Permission } from "./permissions";

export function mapClaimsToPermissions(claim: string): ReadonlySet<Permission> {
  const permissions = [];

  const claimPermissions =
    claimPermissionsLookup[claim.trim().toLowerCase()] ?? [];
  permissions.push(...claimPermissions);

  return new Set(permissions);
}

const claimPermissionsLookup: {
  readonly [claim: string]: readonly Permission[] | undefined;
} =
  /* 🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨
   *                  This should not be adjusted manually!
   * 🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨
   *
   * Please see "Importing the Sheet" in the `/docs/permissions.md`
   * documentation for details.
   */
  // Don't move/remove this comment (used for automated replacement): ✂️
  {
    admin: [
      Permission.AddCommentOnMoveRequest,
      Permission.AddEditDoorCollection,
      Permission.AddEditLocation,
      Permission.AddEditPartner,
      Permission.AddEditRFID,
      Permission.AddEditSite,
      Permission.AddEditTrailerType,
      Permission.BackToPendingMoveRequest,
      Permission.CompleteMoveRequest,
      Permission.CreateMoveRequest,
      Permission.CreateMoveRequestFromDockActivity,
      Permission.CreateNewTrailer,
      Permission.DeleteDoorCollection,
      Permission.DeleteEditLocation,
      Permission.DeleteMoveRequest,
      Permission.DeleteRFID,
      Permission.DeleteSCAC,
      Permission.EditAppointmentStatus,
      Permission.EditDefaultSCAC,
      Permission.EditDisplayFieldsSettings,
      Permission.EditGeneralSiteSettings,
      Permission.EditLocationSetOutOfService,
      Permission.EditMoveRequest,
      Permission.EditTrailerDetails,
      Permission.EditTrailerLocation,
      Permission.EditTrailerStatus,
      Permission.LiveSpotTrailerToDoorAsEmpty,
      Permission.ManageGuardPromptSettings,
      Permission.ManageSpotTruckInspectionSettings,
      Permission.PauseMoveRequest,
      Permission.PullTrailerToYardAsEmpty,
      Permission.ViewDashboard,
      Permission.ViewDisplayFieldsSettings,
      Permission.ViewDockActivity,
      Permission.ViewDoorCollections,
      Permission.ViewDropTrailerList,
      Permission.ViewGeneralSiteSettings,
      Permission.ViewGlobalSettings,
      Permission.ViewLocationList,
      Permission.ViewMoveRequest,
      Permission.ViewMoveRequestList,
      Permission.ViewMoveRequestListActions,
      Permission.ViewNewSignUpsList,
      Permission.ViewOffComplexList,
      Permission.ViewPartnerList,
      Permission.ViewPurchaseOrderInformation,
      Permission.ViewPurchaseOrderList,
      Permission.ViewRFIDList,
      Permission.ViewReports,
      Permission.ViewScacList,
      Permission.ViewSiteList,
      Permission.ViewSiteSettings,
      Permission.ViewTrailerDetails,
      Permission.ViewTrailerTypes,
    ],
    partneradmin: [
      Permission.AddCommentOnMoveRequest,
      Permission.AddEditDoorCollection,
      Permission.AddEditLocation,
      Permission.AddEditRFID,
      Permission.AddEditTrailerType,
      Permission.BackToPendingMoveRequest,
      Permission.CompleteMoveRequest,
      Permission.CreateMoveRequest,
      Permission.CreateMoveRequestFromDockActivity,
      Permission.CreateNewTrailer,
      Permission.DeleteDoorCollection,
      Permission.DeleteEditLocation,
      Permission.DeleteMoveRequest,
      Permission.DeleteRFID,
      Permission.DeleteSCAC,
      Permission.EditAppointmentStatus,
      Permission.EditLocationSetOutOfService,
      Permission.EditMoveRequest,
      Permission.EditTrailerDetails,
      Permission.EditTrailerLocation,
      Permission.EditTrailerStatus,
      Permission.LiveSpotTrailerToDoorAsEmpty,
      Permission.ManageGuardPromptSettings,
      Permission.ManageSpotTruckInspectionSettings,
      Permission.PauseMoveRequest,
      Permission.PullTrailerToYardAsEmpty,
      Permission.ViewDashboard,
      Permission.ViewDisplayFieldsSettings,
      Permission.ViewDockActivity,
      Permission.ViewDoorCollections,
      Permission.ViewDropTrailerList,
      Permission.ViewGeneralSiteSettings,
      Permission.ViewLocationList,
      Permission.ViewMoveRequest,
      Permission.ViewMoveRequestList,
      Permission.ViewMoveRequestListActions,
      Permission.ViewOffComplexList,
      Permission.ViewPurchaseOrderInformation,
      Permission.ViewPurchaseOrderList,
      Permission.ViewRFIDList,
      Permission.ViewReports,
      Permission.ViewScacList,
      Permission.ViewSiteSettings,
      Permission.ViewTrailerDetails,
      Permission.ViewTrailerTypes,
    ],
    dockcoordinator: [
      Permission.AddCommentOnMoveRequest,
      Permission.BackToPendingMoveRequest,
      Permission.CompleteMoveRequest,
      Permission.CreateMoveRequest,
      Permission.CreateMoveRequestFromDockActivity,
      Permission.CreateNewTrailer,
      Permission.DeleteMoveRequest,
      Permission.EditAppointmentStatus,
      Permission.EditLocationSetOutOfService,
      Permission.EditMoveRequest,
      Permission.EditTrailerDetails,
      Permission.EditTrailerStatus,
      Permission.LiveSpotTrailerToDoorAsEmpty,
      Permission.PauseMoveRequest,
      Permission.PullTrailerToYardAsEmpty,
      Permission.ViewDashboard,
      Permission.ViewDockActivity,
      Permission.ViewDropTrailerList,
      Permission.ViewMoveRequest,
      Permission.ViewMoveRequestList,
      Permission.ViewMoveRequestListActions,
      Permission.ViewOffComplexList,
      Permission.ViewPurchaseOrderInformation,
      Permission.ViewPurchaseOrderList,
      Permission.ViewReports,
      Permission.ViewTrailerDetails,
    ],
    guard: [
      Permission.AddCommentOnMoveRequest,
      Permission.CreateMoveRequest,
      Permission.CreateNewTrailer,
      Permission.EditAppointmentStatus,
      Permission.EditMoveRequest,
      Permission.EditTrailerDetails,
      Permission.EditTrailerStatus,
      Permission.ViewDashboard,
      Permission.ViewDockActivity,
      Permission.ViewMoveRequest,
      Permission.ViewMoveRequestList,
      Permission.ViewMoveRequestListActions,
      Permission.ViewOffComplexList,
      Permission.ViewPurchaseOrderInformation,
      Permission.ViewPurchaseOrderList,
      Permission.ViewReports,
      Permission.ViewTrailerDetails,
    ],
    driver: [
      Permission.AddCommentOnMoveRequest,
      Permission.BackToPendingMoveRequest,
      Permission.CompleteMoveRequest,
      Permission.CreateDriverMoveRequest,
      Permission.CreateMoveRequest,
      Permission.CreateSpotTruckInspection,
      Permission.EditDriverMoveRequest,
      Permission.OnLoginCollapseMenu,
      Permission.PauseMoveRequest,
      Permission.StartMoveRequest,
      Permission.UnPauseMoveRequest,
      Permission.ViewMoveRequest,
      Permission.ViewMoveRequestList,
    ],
  };
// 🚨 End of File (don't add anything after this).
